import { createSlice } from "@reduxjs/toolkit";
import { addNewAdsForSchool, deleteAds, getAdsForSchool,getGlobalAds } from "../services/ads_service";

// ----------------------------------------------------------------------

const slice = createSlice({
  name: "ads",
  initialState: {
    isLoadingGetAdsForSchool: false,
    isLoadingAddNewAdsForSchool: false,
    isLoadingDeleteAds: false,
    allSchoolAds: {},
    globalAds:{},
    adsPageNumber: 1
  },

  reducers: {
    setAdsPageNumber: (state, action) => {
      state.adsPageNumber = action.payload
    }
  },

  extraReducers: {

    // get AdsForSchool
    [getAdsForSchool.fulfilled]: (state, action) => {
      state.isLoadingGetAdsForSchool = false;
      state.allSchoolAds = action.payload.data;
    },
    [getAdsForSchool.rejected]: (state, action) => {
      state.isLoadingGetAdsForSchool = false;
    },
    [getAdsForSchool.pending]: (state) => {
      state.isLoadingGetAdsForSchool = true;
    },

     // get AdsForSchool
     [getGlobalAds.fulfilled]: (state, action) => {
      state.isLoadingGetAdsForSchool = false;
      state.globalAds = action.payload.data;
    },
    [getGlobalAds.rejected]: (state, action) => {
      state.isLoadingGetAdsForSchool = false;
    },
    [getGlobalAds.pending]: (state) => {
      state.isLoadingGetAdsForSchool = true;
    },

    // Add New Ads For School
    [addNewAdsForSchool.fulfilled]: (state, action) => {
      state.isLoadingAddNewAdsForSchool = false;
      if (action.payload.message === "Added Successfully") {
        alert(action.payload.message)
        window.location.href = '/dashboard/ads'
      }
    },
    [addNewAdsForSchool.rejected]: (state, action) => {
      state.isLoadingAddNewAdsForSchool = false;
    },
    [addNewAdsForSchool.pending]: (state) => {
      state.isLoadingAddNewAdsForSchool = true;
    },

    // deleteAds
    [deleteAds.fulfilled]: (state, action) => {
      state.isLoadingDeleteAds = false;
      if (action.payload.message === "Deleted Successfully") {
        alert(action.payload.message)
        // window.location.href = '/dashboard/ads'
      }
    },
    [deleteAds.rejected]: (state, action) => {
      state.isLoadingDeleteAds = false;
    },
    [deleteAds.pending]: (state) => {
      state.isLoadingDeleteAds = true;
    },

  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setAdsPageNumber } = slice.actions;
